import React from 'react'
import Me from '../assets/square-me-2.jpg'

export default () =>
  <img 
    src={Me} 
    className="me-img"
  />

